import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { group, ascending, maxIndex } from 'd3-array';
import { defined } from '../../utils/helper';
import { indexOf } from '../../utils/array';
import { columnOf } from './helper';
export function createGroups(groupBy, I, mark) {
  var encode = mark.encode;
  if (groupBy === null) return [I];
  var G = normalizeGroupBy(groupBy).map(function (k) {
    var _a;
    return [k, (_a = columnOf(encode, k)) === null || _a === void 0 ? void 0 : _a[0]];
  }).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      column = _ref2[1];
    return defined(column);
  });
  var key = function key(i) {
    return G.map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        V = _ref4[1];
      return V[i];
    }).join('-');
  };
  return Array.from(group(I, key).values());
}
export function normalizeComparator(order) {
  if (Array.isArray(order)) return createFieldsOrder(order);
  if (typeof order === 'function') return createFunctionOrder(order);
  if (order === 'series') return createSeriesOrder;
  if (order === 'value') return createValueOrder;
  if (order === 'sum') return createSumOrder;
  if (order === 'maxIndex') return createMaxIndexOrder;
  return function () {
    return null;
  };
}
export function applyOrder(groups, comparator) {
  var _iterator = _createForOfIteratorHelper(groups),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _group = _step.value;
      _group.sort(comparator);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
export function domainOf(value, scale) {
  return (scale === null || scale === void 0 ? void 0 : scale.domain) || Array.from(new Set(value));
}
function normalizeGroupBy(groupBy) {
  if (Array.isArray(groupBy)) return groupBy;
  return [groupBy];
}
function createSeriesOrder(data, Y, S) {
  return ascendingComparator(function (i) {
    return S[i];
  });
}
function createFunctionOrder(order) {
  return function (data, Y, S) {
    return ascendingComparator(function (i) {
      return order(data[i]);
    });
  };
}
function createFieldsOrder(order) {
  return function (data, Y, S) {
    return function (i, j) {
      return order.reduce(function (eq, f) {
        return eq !== 0 ? eq : ascending(data[i][f], data[j][f]);
      }, 0);
    };
  };
}
function createValueOrder(data, Y, S) {
  return ascendingComparator(function (i) {
    return Y[i];
  });
}
function createSumOrder(data, Y, S) {
  var I = indexOf(data);
  var groups = Array.from(group(I, function (i) {
    return S[+i];
  }).entries());
  var seriesSum = new Map(groups.map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      k = _ref6[0],
      GI = _ref6[1];
    return [k, GI.reduce(function (s, i) {
      return s + +Y[i];
    })];
  }));
  return ascendingComparator(function (i) {
    return seriesSum.get(S[i]);
  });
}
function createMaxIndexOrder(data, Y, S) {
  var I = indexOf(data);
  var groups = Array.from(group(I, function (i) {
    return S[+i];
  }).entries());
  var seriesMaxIndex = new Map(groups.map(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
      k = _ref8[0],
      GI = _ref8[1];
    return [k, maxIndex(GI, function (i) {
      return Y[i];
    })];
  }));
  return ascendingComparator(function (i) {
    return seriesMaxIndex.get(S[i]);
  });
}
function ascendingComparator(order) {
  return function (i, j) {
    return ascending(order(i), order(j));
  };
}